// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/exclamation-circle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/exclamation-circle'

import { Icon, type IconComponentProps } from '../icon'

export const ExclamationCircleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
